import { Unauthorized } from 'components/unauthorized';

import {
  AdminReportManagement,
  UserReportManagement,
  ProviderReportManagement,
} from 'pages/reports/components';
import { useCanAccess } from 'hooks/useCanAccess';
import { TokenExpired } from 'components/tokenExpired';
import { useIsProvider } from 'hooks';
import { useTutorialStore } from 'store/tutorialStore';
import { TutorialReportManagement } from 'pages/reports/components/TutorialReportManagement';

export const ReportManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('reports');
  const isProvider = useIsProvider();
  const { isTutorialActive } = useTutorialStore();

  const determineComponent = () => {
    if (isExpired) {
      return <TokenExpired />;
    } else if (isTutorialActive) {
      return <TutorialReportManagement />;
    } else if (isAdmin) {
      return <AdminReportManagement />;
    } else if (isProvider) {
      return <ProviderReportManagement />;
    } else if (canAccess) {
      return <UserReportManagement />;
    } else {
      return <Unauthorized />;
    }
  };
  return determineComponent();
};
